export default __webpack_public_path__ + "static/media/Desk-Internacional.9be5ca52.svg";